module.exports = __webpack_public_path__ + "assets/images/Caixa_parabens_0b0add1acb95fdf66127e7a0dcc3ce80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-nine/Caixa_parabens.png
// module id = 247
// module chunks = 0